// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"styles-module__ribbon___1CZfK","ribbonAlt":"styles-module__ribbonAlt___25YOu"};